import { isApiErrorResponse } from 'helpers/rtk-utils';
import { buildQueryParams } from 'helpers/utils';
import { DonorsQueryParams, IDonorData } from 'services/donors/types';

export const buildDonorsUrl = ({
  recipient_id,
  start_date,
  end_date,
  client_id,
  page,
}: DonorsQueryParams): string => {
  const queryString = buildQueryParams({
    start_date,
    end_date,
    client_id: !client_id || client_id === 'None' ? undefined : client_id,
    page,
  });
  const basePath = recipient_id
    ? `/admin/recipients/${recipient_id}/table/donors`
    : '/admin/table/donors';
  return `${basePath}${queryString}`;
};

const centsToDollars = <T extends number | null | undefined>(cents: T): T =>
  (cents == null ? cents : cents / 100) as T;

export const transformDonorsResponse = (response: IDonorData | null): IDonorData => ({
  ...response,
  donors_totals: (response?.donors_totals ?? []).map(donor => ({
    ...donor,
    donation_amount: donor.donation_amount / 100,
    original_donation_amount: centsToDollars(donor.original_donation_amount),
    processing_fee: centsToDollars(donor.processing_fee),
    disbursement_amount: centsToDollars(donor.disbursement_amount),
  })),
});

const DEFAULT_DONORS_ERROR_MESSAGE = 'Failed to load donors';

export const getDonorsErrorMessage = (err: unknown): string => {
  if (isApiErrorResponse(err)) {
    if (err.data && typeof err.data === 'object' && 'message' in err.data) {
      return String((err.data as { message?: unknown }).message ?? DEFAULT_DONORS_ERROR_MESSAGE);
    }
    if (typeof err.error === 'string') {
      return err.error;
    }
  } else if (typeof err === 'object' && err !== null && 'message' in err) {
    return String((err as { message?: unknown }).message ?? DEFAULT_DONORS_ERROR_MESSAGE);
  }

  return DEFAULT_DONORS_ERROR_MESSAGE;
};
